import {
    Box,
    Card,
    CardContent,
    Divider,
    makeStyles,
    Theme,
    Typography,
} from "@material-ui/core";
import { Camera } from "@material-ui/icons";
import Cookies from "js-cookie";
import moment from "moment";
import React, { useEffect } from "react";
import config from "../../../config/apiConfig";

type StoryInfo = {
    title: string;
    cover_image: string;
    short_description: string;
    number_of_comments: number;
    number_of_likes: number;
    number_of_views: number;
    updated_at: Date;
    created_at: Date;
};

const mapToStoryInfo = (story: any): StoryInfo => ({
    ...story,
    updated_at: new Date(story.updated_at * 1000),
    created_at: new Date(story.created_at * 1000),
});

const useStyles = makeStyles((theme: Theme) => ({
    cover: {
        height: 90,
        width: 72,
        objectFit: "cover",
        borderRadius: 4,
    },
    flex: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: theme.spacing(2),
    },
    flex2: {
        display: "flex",
        alignItems: "center",
    },
    flexBox: {
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 6,
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        "& div": {
            textAlign: "center",
        },
        "& h6": {
            fontWeigth: "bold",
        },
        "& p": {
            color: theme.palette.text.secondary,
        },
    },
}));

const StorySection: React.FC<{ id: string }> = ({ id }) => {
    const classes = useStyles();
    const [story, setStory] = React.useState<StoryInfo | null>(null);

    useEffect(() => {
        const formData = new FormData();
        formData.append("session-token", Cookies.get("token") ?? "");
        formData.append("token", config.token);

        const requestParams = {
            method: "POST",
            body: formData,
        };

        fetch(
            config.BASE_URL + "/v1/get/writingtool/story/" + id + "/info",
            requestParams
        )
            .then((res) => res?.json())
            .then((res) =>
                setStory(!!res?.data ? mapToStoryInfo(res.data) : null)
            );
    }, []);

    return (
        <React.Fragment>
            <Card>
                {story && (
                    <CardContent>
                        <img
                            className={classes.cover}
                            src={story.cover_image}
                            alt=""
                        />
                        <Typography variant="subtitle1">
                            <strong>{story.title}</strong>
                        </Typography>
                        <Typography variant="subtitle2" color="textSecondary">
                            Last updated on{" "}
                            {moment(story.updated_at).format(
                                "Do MMMM [at] h:mm a"
                            )}
                        </Typography>
                        <Typography
                            variant="body2"
                            style={{
                                height: 80,
                                overflow: "hidden",
                                marginBottom: 8,
                            }}
                        >
                            {story.short_description}
                        </Typography>
                        <Typography variant="subtitle2" color="textSecondary">
                            Published on{" "}
                            {moment(story.created_at).format(
                                "Do MMMM [at] h:mm a"
                            )}
                        </Typography>
                    </CardContent>
                )}
            </Card>
            <Box mt={2}></Box>
            <Card className={classes.flex}>
                <Typography variant="body2">
                    <strong>Pencil Score</strong>
                </Typography>
                <div className={classes.flex2}>
                    <Camera color="secondary" />{" "}
                    <Typography color="secondary">45%</Typography>
                </div>
            </Card>
            <Box mt={2}></Box>
            <Card className={classes.flexBox}>
                <div>
                    <Typography variant="h5">
                        {story?.number_of_views}
                    </Typography>
                    <Typography variant="body2" component="p">
                        Views
                    </Typography>
                </div>
                <Divider orientation="vertical" flexItem />
                <div>
                    <Typography variant="h5">
                        {story?.number_of_comments}
                    </Typography>
                    <Typography variant="body2" component="p">
                        Comments
                    </Typography>
                </div>
                <Divider orientation="vertical" flexItem />
                <div>
                    <Typography variant="h5">
                        {story?.number_of_likes}
                    </Typography>
                    <Typography variant="body2" component="p">
                        Likes
                    </Typography>
                </div>
            </Card>
        </React.Fragment>
    );
};

export default StorySection;
